import React, { useRef, useEffect } from "react";
import { TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import { connect } from "react-redux";
import CPNotification from "../../pages/Login/CPNotification";
import * as Actions from "../../store/actions/contract/myContractDetailsActions";
import * as StyledGlobalCSS from "../../constants/common/StyledGlobalConstants";
import { useTranslation } from "react-i18next";
import SupportingUrl from "../../constants/SupportingUrl";
import UrlRedirection from "../common/UrlRedirection";
import { DEVICE_BREAKPOINTS, suspendedFinancialStatuses } from "../../constants/appConstants";
import PropTypes from "prop-types";
import { saveStateForNewTab } from "../../util/saveState";

const { DESKTOP } = DEVICE_BREAKPOINTS;

const ReviewContract = (props) => {
  const { t } = useTranslation("contractsTranslation");
  const trackACase = () => {
    saveStateForNewTab();
    let caseId = props.cancellationCaseList && props.cancellationCaseList.length > 0 && props.cancellationCaseList[0]?.caseId;
    let url = window.location.href.toString().includes("localhost")
      ? `http://${window.location.host}/#/support/cases/viewCaseDetails/${caseId}`
      : `https://${window.location.host}/${props.userLanguage}/customer-portal/#/support/cases/viewCaseDetails/${caseId}`;
    window.open(url, "_blank");
  };

  const titleRef = useRef();

  const isSuspendedContractWithNoPayment = () => {
    if (!props.erpBusinessPartner?.data?.contractAccountDetails || 
        !Array.isArray(props.erpBusinessPartner.data.contractAccountDetails) || 
        !props.contractAccountId || 
        !props.paymentStatus?.data) {
      return false;
    }
    // Find the current contract account in the ERP data
    const currentContract = props.erpBusinessPartner.data.contractAccountDetails.find(
      contract => contract?.contractAccountId === props.contractAccountId
    );
    // Find payment status for current contract
    const currentPaymentStatus = props.paymentStatus.data.find(
      item => item.contractAccountId === props.contractAccountId
    );
    // Check if contract is suspended AND payment status is true
    return (
      suspendedFinancialStatuses.includes(currentContract?.financialStatus?.toLowerCase()) && 
      (currentPaymentStatus?.paymentStatus === "false" || currentPaymentStatus?.paymentStatus === null)
    );
  };

  useEffect(() => {
    titleRef.current.focus();
    const htmlElement = document.querySelector("html");
    if (htmlElement) {
      htmlElement.style.overflow = "hidden";
    }
    return () => {
      const htmlElement = document.querySelector("html");
      if (htmlElement) {
        htmlElement.style.overflow = "scroll";
      }
    };
  }, []);

  const renderContractInfo = () => 
    props.reviewContractData.map((contractInfo) => {
      // Use a unique property from contractInfo as key, fallback to JSON string if not available
      const contractKey = contractInfo.contractAccountId || contractInfo.id || JSON.stringify(contractInfo);
      return (
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1.5rem" key={contractKey}>
          {Object.keys(contractInfo).map((info) => {
            return (
              <Wrapper key={info} display="flex" flexDirection="column" alignItems="flex-start" gap="4px">
                <TextWrapper fontFamily="neue-haas-grotesk-display" fontSize="0.875rem" fontWeight="700" lineHeight="1.25rem">
                  {t(info)}
                </TextWrapper>
                <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
                  {contractInfo[info]}
                </TextWrapper>
              </Wrapper>
            );
          })}
        </Wrapper>
      );
    });

  const gapValue = () => props.notification || props.isDuplicateRequest ? "1rem" : "4rem";
  const marginTopVal = () => props.windowSize.width < DESKTOP ? "1.5rem" : "3rem";
  const paddingBottomVal = () => props.windowSize.width < DESKTOP ? "12rem" : "";
  const roleTxt = () => (!props.isDuplicateRequest && !props.notification) ? "alert" : "none";
  const ariaLiveTxt = () => (!props.isDuplicateRequest && !props.notification) ? "assertive" : "off";

  function renderReviewContractContent(spinner, reviewContractData, renderContractInfo) {
    if (spinner) {
      return null;
    }
    if (reviewContractData.length !== 0) {
      return renderContractInfo();
    }
    return null;
  }

  return (
      <Wrapper
        display="inline-flex"
        flexDirection="column"
        alignItems="flex-start"
        gap={gapValue()}
        marginTop={marginTopVal()}
        marginBottom="1rem"
        paddingBottom={paddingBottomVal()}
        role={roleTxt()}
        aria-live={ariaLiveTxt()}
      >
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1.5rem">
          <TextWrapper ref={titleRef} fontFamily="neue-haas-grotesk-display" fontSize="2.5rem" fontWeight="700"  aria-level={1} lineHeight="3rem">
            {props.pageTitle}
          </TextWrapper>

          <CPNotification
            isOpen={props.isDuplicateRequest}
            notificationType="error"
            closeButton={false}
            width="auto"
            height="auto"
            message={t("We have already received a " + props.contractDetailsType + " request for this account.")}
          >
            <TextWrapper fontSize="0.875rem">
              {t("We have already received a " + props.contractDetailsType + " request for this account.")}
            </TextWrapper>
          </CPNotification>

          {!props.isDuplicateRequest && (
            <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" id="more-info">
              {`${props.pageBodyText} `}
              <UrlRedirection
                label={t("FAQ: Contracts and cancellations")}
                link={SupportingUrl.FAQ_ContractsAndCancellation}
                ariaLabel={t("FAQ: Contracts and cancellations")}
              />
              {"."}
            </TextWrapper>
          )}

          <CPNotification
            isOpen={props.notification}
            notificationType="error"
            closeButton={false}
            width="auto"
            height="auto"
            message={t("There was an issue when submitting your information. Try again.")}
          >
            <TextWrapper fontSize="0.875rem">{t("There was an issue when submitting your information. Try again.")}</TextWrapper>
          </CPNotification>
        </Wrapper>

        {props.isDuplicateRequest ? (
          <>
            <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
              {t("Your case is in progress. You can only add extra details, or cancel it.")}
            </Wrapper>
            {props.contractDetailsType === "change" && (
              <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
                {t("Once the case is complete you can submit a new change request, if necessary.")}
              </Wrapper>
            )}
            {suspendedFinancialStatuses.includes(props.accountFinancialStatus?.toLowerCase()) && isSuspendedContractWithNoPayment()
              ? <></> 
              : <div style={{ textAlign: "left" }}>
              <StyledGlobalCSS.CustomisedTextLink
                fontSize="0.875rem"
                style={{
                  color: "#0077B4",
                }}
                id="my-contract-view-existing-case"
                onClick={() => trackACase()}
                tabIndex={0}
              >
                {t("View existing case")}
              </StyledGlobalCSS.CustomisedTextLink>
            </div>}
          </>
        ) : renderReviewContractContent(props.spinner, props.reviewContractData, renderContractInfo)}
      </Wrapper>
  );
};

const mapDispatchToProps = {
  getActiveCancellationCaseList: Actions.getActiveCancellationCasesList,
};

const mapStateToProps = (state) => {
  return {
    windowSize: state.ACCOUNT.windowSize,
    userLanguage: state.ACCOUNT.userLanguage,
    cancellationCaseList: state.CONTRACT.cancellationCaseList,
    isDuplicateRequest: state.CONTRACT.isDuplicateRequest,
    accountFinancialStatus: state.ACCOUNT.accountFinancialStatus,
    paymentStatus: state.ACCOUNT.paymentStatus,
    erpBusinessPartner: state.ACCOUNT.erpBusinessPartner,
    contractAccountId: state.BILLING.contractId,
  };
};

ReviewContract.propTypes = {
  cancellationCaseList: PropTypes.array,
  windowSize: PropTypes.object,
  userLanguage: PropTypes.string,
  isDuplicateRequest: PropTypes.bool,
  accountFinancialStatus: PropTypes.string,
  paymentStatus: PropTypes.object,
  erpBusinessPartner: PropTypes.object,
  contractAccountId: PropTypes.any,
  pageTitle: PropTypes.string,
  pageBodyText: PropTypes.string,
  reviewContractData: PropTypes.array,
  notification: PropTypes.any,
  contractDetailsType: PropTypes.string,
  spinner: PropTypes.any,
};

ReviewContract.defaultProps = {
  windowSize: {},
  pageTitle: "",
  pageBodyText: "",
  reviewContractData: [{}],
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewContract);